// Maximum file size for attachments: 35MB
export const MAX_ATTACHMENT_FILE_SIZE = 35 * 1024 * 1024;

// The common extensions POST /content/medias accepts. qcreate checks the
// extension (Content::MediasController::ALLOWED_MIME_TYPES), so list extensions
// here too. Rare ones the server also takes (.mpga, .ogx) are left out.
export const MEDIA_UPLOAD_ACCEPT = {
  image: '.png,.jpg,.jpeg,.gif,.webp,.bmp,.jfif,.jpe,.pjpeg',
  audio: '.mp3,.m4a,.wav,.ogg,.oga',
};

export const UNSUPPORTED_MEDIA_TYPE_ERROR = 'unsupported_media_type';

export const FILE_MIME_TYPES = [
  'archive',
  'audio',
  'code-markup',
  'office-docs',
  'image',
  'video',
];

export interface FileUploadOptions {
  enabled: boolean;
  mandatory: boolean;
  categories: string[];
}

export const DEFAULT_FILE_UPLOAD_OPTIONS = {
  enabled: false,
  mandatory: true,
  categories: [],
};
